import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-reset-password-dialog',
    template: `
    <h1 mat-dialog-title>Redefinir Senha</h1>
    <div mat-dialog-content>
      <mat-form-field class="w-100">
        <mat-label>Nova Senha</mat-label>
        <input matInput [(ngModel)]="newPassword" type="password" />
      </mat-form-field>
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="onCancel()">Cancelar</button>
      <button mat-flat-button color="primary" [disabled]="!newPassword" (click)="onConfirm()">Confirmar</button>
    </div>
  `,
    standalone: false
})
export class ResetPasswordDialogComponent {
  newPassword: string = '';

  constructor(
    public dialogRef: MatDialogRef<ResetPasswordDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    this.dialogRef.close(this.newPassword);
  }

}
